import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import moment from 'moment';
import { toast } from 'react-toastify';
import useHospitalCoverateContext from './context/useHospitalCoverateContext';
import Filter from './components/Filter';
import Table from './components/Table';
import {
  getHospitalCoverageReport,
  getHospitalCoverageReportExport,
} from '../../api/hospitalCoverageApi';

export default function HospitalCoverageDashboard() {
  const defaultFilter = {
    department: { label: 'ALL', value: '' },
    team: { label: 'ALL', value: '' },
    manager_id: { label: 'ALL', value: '' },
    rep_id: { label: 'ALL', value: '' },
    account_type: { label: 'ALL', value: '' },
    date_filter_type: { label: 'Today', value: 'today' },
    date_from: moment().format('YYYY-MM-01'),
    date_to: moment().format('YYYY-MM-DD'),
  };

  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [loading, setLoading] = useState(true);
  const [totalUnassigned, setTotalUnassigned] = useState(0);
  const [coverageData, setCoverageData] = useState([]);

  const handleGenerateReport = async (clear = null) => {
    try {
      setLoading(true);
      let request;

      if (clear === 'reset') {
        request = {
          department: defaultFilter.department.value,
          team: defaultFilter.team.value,
          manager_id: defaultFilter.manager_id.value,
          specialist: defaultFilter.rep_id.value,
          account_type: defaultFilter.account_type.value,
          date_filter_type: defaultFilter?.date_filter_type?.value,
          date_from: defaultFilter?.date_from,
          date_to: defaultFilter?.date_to,
        };
      } else {
        request = {
          department: filterForm.department.value,
          team: filterForm.team.value,
          manager_id: filterForm.manager_id.value,
          specialist: filterForm.rep_id.value,
          account_type: filterForm.account_type.value,
          date_filter_type: filterForm?.date_filter_type?.value,
          date_from: filterForm?.date_from,
          date_to: filterForm?.date_to,
        };
      }
      const response = await getHospitalCoverageReport(request);
      const { code, data } = response.data;

      if (code === '200') {
        setCoverageData(data);
        setTotalUnassigned(response?.data?.total_unassigned);
      }
      setLoading(false);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleExport = async () => {
    try {
      toast.loading('Please wait ...');
      const request = {
        department: filterForm.department.value,
        team: filterForm.team.value,
        manager_id: filterForm.manager_id.value,
        specialist: filterForm.rep_id.value,
        account_type: filterForm.account_type.value,
        date_filter_type: filterForm?.date_filter_type?.value,
        date_from: filterForm?.date_from,
        date_to: filterForm?.date_to,
      };
      const res = await getHospitalCoverageReportExport(request);
      const { code, result, message } = res.data.response;
      if (code !== '200') {
        throw Object.assign(new Error(message), { code: 402 });
      }
      toast.dismiss();
      window.location.href = result;
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  useEffect(() => {
    handleGenerateReport();
  }, []);
  return (
    <useHospitalCoverateContext.Provider
      value={useMemo(
        () => ({
          defaultFilter,
          loading,
          filterForm,
          coverageData,
          totalUnassigned,
          setFilterForm,
          setCoverageData,
          setLoading,
          handleGenerateReport,
          handleExport,
        }),
        [loading, filterForm, coverageData],
      )}
    >
      <div className='body-content'>
        <Box sx={{ backgroundColor: '#fff', boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={12} md={12}>
                  <Box sx={{ backgroundColor: '#fff' }} mt={4} p={2}>
                    <Table />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </div>
    </useHospitalCoverateContext.Provider>
  );
}
